/**
 * GridSkeleton Component
 *
 * Renders a grid of skeleton cards for loading states.
 */

import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import CardSkeleton from "./CardSkeleton";

function GridSkeleton({ count = 6, hasImage = true, hasButton = false }) {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <CardSkeleton hasImage={hasImage} hasButton={hasButton} />
        </Grid>
      ))}
    </Grid>
  );
}

GridSkeleton.propTypes = {
  count: PropTypes.number,
  hasImage: PropTypes.bool,
  hasButton: PropTypes.bool,
};

export default GridSkeleton;
